export default __webpack_public_path__ + "static/media/Affinity_Rev_04.17d3ca4a.svg";